"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var FacebookPost_1 = tslib_1.__importDefault(require("./FacebookPost"));
var FacebookVideo_1 = tslib_1.__importDefault(require("./FacebookVideo"));
var Facebook = function (_a) {
    var _b = _a.config, data_type = _b.data_type, data_href = _b.data_href, config = _a.config, renderEmpty = _a.renderEmpty;
    if (!data_href || !data_type) {
        if (renderEmpty) {
            return renderEmpty('social');
        }
        return null;
    }
    switch (data_type) {
        case 'post':
            return React.createElement(FacebookPost_1["default"], { config: config });
        case 'video':
            return React.createElement(FacebookVideo_1["default"], { config: config });
        default:
            return renderEmpty ? renderEmpty('social') : null;
    }
};
exports["default"] = Facebook;
